import { Component, OnInit, NgZone } from '@angular/core';
import { HelperService } from '../helper.service';
import { UserService } from '../user.service';
import {Router,ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner"; 
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { CreateAdminComponent } from '../create-admin/create-admin.component';
import {AuthGuardService} from '../auth-guard.service';
@Component({
  selector: 'app-manage-subscriptions',
  templateUrl: './manage-subscriptions.component.html',
  styleUrls: ['./manage-subscriptions.component.css']
})
export class ManageSubscriptionsComponent implements OnInit {
  loadStripe() {
     
    if(!window.document.getElementById('stripe-script')) {
      var s = window.document.createElement("script");
      s.id = "stripe-script";
      s.type = "text/javascript";
      s.src = "https://js.stripe.com/v2/";
      s.onload = () => {
        window['Stripe'].setPublishableKey(this.userService.stripe_key());
      }
      window.document.body.appendChild(s);
    }
  }
  constructor(private userService : UserService, private route: ActivatedRoute, private router : Router, private SpinnerService: NgxSpinnerService, private CreateAdminComponent:CreateAdminComponent, private zone: NgZone, private authGuard: AuthGuardService) {
    //alert('1234');
    this.authGuard.userPermissions();
    this.userService.getUnAllottedLicensesList().subscribe((res)=>{
       if(res.status == 1){
       const unllotedLinces = 'yes';
       localStorage.setItem('unllotesLinces',unllotedLinces); 
        //this.router.navigate(['/allot-license'])
      }  
    })

  }
  licenseCount : number;
  licenseId = '';
  add_card_submitted = false;
  yearList= [];
  StripeCardEror:string = "";
  cardListWorking = [];
  cardCountWorking = [];
  cardSelectMessage = "";
  card_form_submitted = false;
  transaction_id =  this.route.snapshot.params['id'];
  adminButtonActive = false;
  divReady = false;
  subscription = [];
  hasSubscription = false;
  product_image_url = this.userService.product_image_url;
  allottedLicenses = [];
  productname = '';
  AdminData = [];
  productPackage = [];
  status = '0';
  adminMessage: string = '';
  productImage = '';
  package_id :string = '';
  subscriptionSubmitClick = false;
  package_type:string='month';
  planSuccessMessage='';
  planErrorMessage = '';
  cardList = [];
  planList = [];
  cardCount = "";
  license_count:any = "";
  admin_form_submit = false;
  buttonLoading = false;
  productName = '';
  productIcon = '';
  ngOnInit(): void {
    this.loadStripe();
    this.SpinnerService.show(); 
    window.scrollTo(0,0);
    this.manageLicences();
    this.userCards();
    this.getUserCardsWorking();
    const user_id = localStorage.getItem('nu_c_user_id') ;
    this.userService.getYearList().subscribe((data: any) => {
      this.yearList = data;
    });
    this.userService.getProductTransactionsSingle(user_id,this.transaction_id).subscribe((data: any) => {
      //console.log(data);
      console.log(data);
      if (data.status == 1 && data.transactions) {
        this.productName = data.productDetail['name'];
        this.productIcon = data.productDetail['icon'];
        this.hasSubscription = true;
        this.subscription = data.transactions;
        this.package_id = data.transactions.package_id;
        ////console.log(data.transactions.package_id);
       // this.subscription_form['controls']['package_id'].patchValue(this.package_id);
      }
      else{
        this.router.navigate(['/subscriptions']);
      }
      this.SpinnerService.hide(); 
      this.divReady = true;
      
    });
    this.getPackageList();
    this.getUserPlans();

  }
  admin_select_form = new FormGroup({
    license_id: new FormControl("", [Validators.required]),
    admin_id: new FormControl("", [Validators.required]),
  });
  
  get admin_select_f(){
    return this.admin_select_form.controls;
  }
  
  admin_select_submit(){
    this.admin_form_submit = true;
    this.SpinnerService.show();
    if (this.admin_select_form.invalid || this.status == '0') {
      this.SpinnerService.hide(); 
      return;
    }
    const admin_id = this.admin_select_form.value.admin_id;
    const license_id = this.admin_select_form.value.license_id;
    this.userService.updateLicenseAdmin(license_id,admin_id).subscribe((data: any) => {
      this.SpinnerService.hide();
      //console.log(data);
      if (data.status == 1) {
        this.adminMessage = data.msg;
        this.manageLicences();
        setTimeout(() => {
          this.adminMessage = '';
          const close_s_admin = document.querySelector('.close_s_admin');
          if (close_s_admin instanceof HTMLElement) {
            close_s_admin.click();
          }
          this.admin_select_form.reset();
          this.admin_form_submit = false;
        }, 2000);
      }
    });
  }
  changeAdminUser(license_id){
    ////console.log(license_id);
    this.admin_select_form.controls.license_id.patchValue(license_id);
  }
  addAdmin(){
    this.CreateAdminComponent.addAdmin();
  }
  getPackageList(){
    this.userService.getProductPackageAll(this.package_type).subscribe((data: any) => {
      if (data.status == 1) {
       // ////console.log(data);
        let i = 0;
        let array = [];
        var license_count_arr = localStorage.getItem('license_count_arr') != null ? JSON.parse(localStorage.getItem('license_count_arr')): {};
        if(data.productPackage.length>0){
          this.productImage = data.productPackage[0].icon;
          data.productPackage.forEach(function (value) {
            
            const selected_license = license_count_arr !== undefined && license_count_arr[value.id] !== undefined && license_count_arr[value.id] != null ? license_count_arr[value.id] : '1';
            value.description_points = JSON.parse(value.description_points);
            value.selected_license = selected_license;
            array[i] = value;
            i++;
          });
        }
        this.productPackage = array;
        this.SpinnerService.hide(); 
        ////console.log(this.productPackage);
      }
      
    });
  }
  manageLicences(){
    this.userService.getAllottedLicensesList(this.transaction_id).subscribe((data: any) => {
      const proDuctid = this.transaction_id;
      //console.log(data);
      //localStorage.setItem('proDuctid', proDuctid);
      if (data.status == 1) {
        console.log(data.subscription_info);
        this.licenseCount = data.subscription_info.length;
        this.allottedLicenses = data.subscription_info
        this.productname = data.product_name
        this.userService.getAdminUsers().subscribe((res) => {
          this.AdminData = res.admin_users;

        });

      }
    })
  }
  cancelSubscription(id){
    ////console.log(id);
    if (confirm("Are you sure you want to cancel the subscription?")) {
      this.SpinnerService.show(); 
      this.userService.Cancellicenses(id).subscribe((res) => {
        this.SpinnerService.hide(); 
        this.manageLicences();
      })
    }
  }

  selectPackage(event) {
    this.planSuccessMessage = '';
    this.planErrorMessage = '';
  }


  SelectedAdmin(event) {
    this.adminButtonActive = false;
    this.status = '0';
    this.adminMessage = '';
    this.admin_form_submit = false;
    const product_id = localStorage.getItem('proDuctid');
    ////console.log(event);
    ////console.log(this.transaction_id);
    if(event){
      ////console.log('work');
      this.userService.validateAdminUser(event, this.transaction_id).subscribe((res => {
        this.adminButtonActive = true;
        if (res.status == 3) {
          this.status = '0';
          this.adminMessage = "Admin user already assigned";
          return
        } else {
          this.status = '1';
        }
      }));
    }
    else{
      ////console.log('not work');
      this.adminMessage = '';
    }
  }

  subscription_form = new FormGroup({
    package_id: new FormControl(this.package_id, [Validators.required]),
    license_id: new FormControl('', [Validators.required]),
    package_type: new FormControl('', [Validators.required]),
    free_plan: new FormControl('', [Validators.required]),
  });
  
  get subscription_f(){
    return this.subscription_form.controls;
  }
  
  submit_subscription(){
    this.planSuccessMessage = '';
    this.planErrorMessage = '';
    this.SpinnerService.show(); 
    this.subscriptionSubmitClick = true;
   // ////console.log(this.subscription_form.value);
    const license_id = this.subscription_form.value.license_id;
    const package_id = this.subscription_form.value.package_id;
    const package_type = this.subscription_form.value.package_type;
    const free_plan = this.subscription_form.value.free_plan;
    if (this.subscription_form.invalid) {
      this.SpinnerService.hide(); 
      return;
    }
    this.userService.changeSubscription(license_id, package_id, package_type,free_plan).subscribe((res => {
      this.SpinnerService.hide(); 
      ////console.log(res);
      if(res.status == 1){
        this.manageLicences();
        this.planSuccessMessage = res.msg;
        setTimeout(() => {
          this.planSuccessMessage = '';
          this.planErrorMessage = '';
          const cancelbttn = document.querySelector('.cancelbttn_plan');
          if (cancelbttn instanceof HTMLElement) {
              cancelbttn.click();
          }
        }, 1500);
      }
      if(res.status == 2){
        this.planErrorMessage = res.msg;
      }
      
      /* if (res.status == 3) {
        this.status = '0';
        this.adminMessage = "Admin user already assigned"
        return
      } else {
        this.status = '1';
        localStorage.setItem('selected_admin', event);
      } */
    }));
  }

  changePlan(event,isFreePlan){
    //console.log(isFreePlan);
    this.planErrorMessage = "";
    this.subscriptionSubmitClick = false;
    this.subscription_form['controls']['license_id'].patchValue(event);
    this.subscription_form['controls']['free_plan'].patchValue(isFreePlan);
    this.subscription_form['controls']['package_type'].patchValue("");
    this.subscription_form['controls']['package_id'].patchValue("");
  }
  changePlanType(event){
    this.package_type = event;
    this.getPackageList();
    this.subscription_form['controls']['package_id'].patchValue("");
    this.planErrorMessage = "";
    this.planSuccessMessage = "";
  }

  userCards(){
    this.userService.getUserCards().subscribe((res => {
      if(res.status == 1){
        this.cardList = res.card;
        this.cardCount = res.card.length;
      }
    }));
  }
  
  getUserCardsWorking(){
    this.userService.getUserCardsWorking().subscribe((res => {
      //console.log(res);
      if(res.status == 1){
        this.cardListWorking = res.card;
        this.cardCountWorking = res.card.length;
      }
    }));
  }
  
  getUserPlans(){
    this.userService.getUserPlans().subscribe((res => {
      ////console.log(res);
      if(res.status == 1){
        this.planList = res.plan;
        this.license_count = res.license_count;
        ////console.log(this.planList.length);
      }
    }));
  }
  SelectedCard(event){
    ////console.log(event);
  }
  

  card_form = new FormGroup({
    card_id: new FormControl('', [Validators.required]),
    license_id: new FormControl(''),
  });
  
  get card_f(){
    return this.card_form.controls;
  }
  
  card_submit(){
    this.SpinnerService.show();
    this.card_form_submitted = true;
    if(this.card_form.invalid){
      this.SpinnerService.hide();
      return false;
    }
    const card_id = this.card_form.value.card_id;
    const license_id = this.card_form.value.license_id;
    ////console.log(this.card_form.value);return false;
    this.userService.updateLicenseCard(card_id,license_id).subscribe((data: any) => {
      this.SpinnerService.hide();
      //console.log(data);
      if (data.status == 1) {
        this.cardSelectMessage = data.msg;
        this.ngOnInit();
        setTimeout(() => {
          this.cardSelectMessage = '';
          const close_card_mdl = document.querySelector('.close_card_mdl');
          if (close_card_mdl instanceof HTMLElement) {
            close_card_mdl.click();
          }
          this.card_form.reset();
          this.card_form_submitted = false;
        }, 1500);
      }
    });
  }
  selectCard(){
    this.card_form_submitted = false;
    this.licenseId = '';
    this.card_form.get("card_id").setValue("");
    //this.card_form.get('license_id').clearValidators();
   // this.card_form.get('license_id').updateValueAndValidity();
  }
  selectCardSingle(event){
    this.card_form_submitted = false;
    this.card_form.get("card_id").setValue("");
    this.card_form.get("license_id").setValue(event);
    this.licenseId = event;
    //this.card_form.get('license_id').setValidators([Validators.required]);
    //this.card_form.get('license_id').updateValueAndValidity();
  }
  addNewCard(){
    const close_card_mdl = document.querySelector('.close_card_mdl');
    if (close_card_mdl instanceof HTMLElement) {
      close_card_mdl.click();
    }
  }

  add_card_form = new FormGroup({
    name: new FormControl('', [Validators.required]),
    number: new FormControl('', [Validators.required]),
    exp_month: new FormControl('', [Validators.required]),
    exp_year: new FormControl('', [Validators.required]),
    cvv: new FormControl('', [Validators.required]),
  });
  
  get add_card_f(){
    return this.add_card_form.controls;
  }
  
  add_card_submit(){
    this.buttonLoading = true;
    //this.StripeCardEror = '';
    this.add_card_submitted = true;
    this.SpinnerService.show();
    ////console.log(this.add_card_form.value);
    if(this.add_card_form.invalid){
      this.buttonLoading = false;
      this.SpinnerService.hide();
      return false;
    }
    //console.log(this.add_card_form.value);
    const CardNumber = this.add_card_form.get('number').value.trim();
    const Expirationdate = this.add_card_form.get('exp_month').value;
    const expYear = this.add_card_form.get('exp_year').value;
    const CVV = this.add_card_form.get('cvv').value.trim();
    if (!window['Stripe']) {
      alert('Oops! Stripe did not initialize properly.');
      return;
    }
    (<any>window).Stripe.card.createToken({
      number: CardNumber,
      exp_month: Expirationdate,
      exp_year: expYear,
      cvc: CVV,
    }, (status: number, response: any) => {
      this.zone.run(() => {
        this.buttonLoading = false;
        this.SpinnerService.hide();
        if (status == 200) {
          this.StripeCardEror = '';
          const stripe_token = response.id ;
          const card_id = response.card.id;
          this.userService.addUserCard(card_id,stripe_token,this.licenseId).subscribe((result)=>{
            if (result.status == 1) {
              this.StripeCardEror = result.msg;
              //this.ngOnInit();
              this.userCards();
              setTimeout(() => {
                this.ngOnInit();
                this.StripeCardEror = '';
                const close_card_mdl_add = document.querySelector('.close_card_mdl_add');
                if (close_card_mdl_add instanceof HTMLElement) {
                  close_card_mdl_add.click();
                }
                
                /* const changeCardBtn = document.querySelector('.changeCardBtn');
                if (changeCardBtn instanceof HTMLElement) {
                  changeCardBtn.click();
                } */
                //this.add_card_form.reset();
                this.add_card_form.get('number').setValue("");
                this.add_card_form.get('exp_month').setValue("");
                this.add_card_form.get('exp_year').setValue("");
                this.add_card_form.get('cvv').setValue("");
                this.add_card_submitted = false;
              }, 1000);
            }
            else{
              this.StripeCardEror = result.validationErrors.card;
            }
          });
        } else {
            this.StripeCardEror = response.error.message;
            this.buttonLoading = false;
        }
      });
     
      
    });
   
  }
}
